import { VF_DROPDOWN } from 'AppSrc/core/components/forms/form-base-components/v-f-dropdown';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';


const fieldId = 'services';

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_DROPDOWN);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please select Service' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

const initialValues = null;

const vFParams = {
  fieldTitle: 'Which service needs to change?',
  placeholder: 'Please select',
};

const whichServiceNeedsToChange = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_DROPDOWN,
};

export { whichServiceNeedsToChange };
